var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SlideSidebarContainer',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('span',[_vm._v("Categorias")])]},proxy:true}])},[_c('CategoriesNavbar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }